import React from "react";
import SeriesIndex from "./series_index";

const WebIndustryIntroductionIndex = () => {
  return (
    <SeriesIndex
      seriesItems={[
        { url: "el-internet", title: "Conociendo más sobre el Internet" },
        {
          url: "la-web",
          title: "La Web (WWW o World Wide Web) ¿En qué consiste?"
        },
        {
          url: "tecnologias-web",
          title: "Tecnologías que funcionan en la Navegación Web"
        },
        {
          url: "beneficios-soluciones-web",
          title: "Beneficios y oportunidades de la Industria Web"
        }
      ]}
    />
  );
};

export default WebIndustryIntroductionIndex;
